<template>
  <div>
    <span v-for="tag in tags" class="badge badge-info">{{ tag.tag }}</span>
  </div>
</template>

<script>
export default {
  props: ['tags']
}
</script>
